<script>
import { getColorVariant, getVariant } from "../../helpers/badgeLookupTable";
import StackedChart from "./StackedChart.vue";
/*
    //Estado visto bueno
    'estado_vb' => [
        'Pendiente',
        'Aprobado',
        'Inmovilizado',
        'Pendiente de Inspección',
        'Presentado',
        'Rechazado'
    ],
*/

export default {
  components: { StackedChart },
  props: {
    data: [Object, undefined],
    irADespachosPendientes: Function,
  },
  data() {
    return {};
  },
  computed: {
    parsedData() {
      return [
        {
          label: "Pendiente",
          value: this.data?.pendiente,
          color: getColorVariant("Pendiente"),
        },
        {
          label: "Aprobado",
          value: this.data?.aprobado,
          color: getColorVariant("Aprobado"),
        },
        {
          label: "Inmovilizado",
          value: this.data?.retirado_con_multa,
          color: getColorVariant("Inmovilizado"),
        },
        {
          label: "Pendiente de Inspección",
          value: this.data?.pendiente_inspeccion,
          color: getColorVariant("Pendiente de Inspección"),
        },
        {
          label: "Presentado",
          value: this.data?.presentado,
          color: getColorVariant("Presentado"),
        },
        {
          label: "Rechazado",
          value: this.data?.rechazado,
          color: getColorVariant("Rechazado"),
        },
      ];
    },
  },
  methods: {
    getVariant(estado) {
      return getVariant(estado);
    },
  },
};
</script>

<template>
  <div id="charts" class="flex flex-col gap-4 h-full">
    <!--
    <div class="mx-auto">
      <slot name="ver"></slot>
    </div>
    -->

    <h5 class="!font-bold text-left">Vistos Buenos</h5>

    <div class="flex flex-row gap-2 p-4">
      <div class="w-56">
        <stacked-chart :data="parsedData" />
      </div>

      <div class="flex flex-col gap-4 w-full">
        <div
          v-for="(estado, i) in parsedData"
          :key="i"
          class="flex flex-row items-center gap-2 w-full"
        >
          <div
            class="h-4 w-4 rounded-full aspect-square"
            :class="[getVariant(estado.label)]"
          ></div>
          <span
            class="cursor-pointer text-left"
            @click="
              irADespachosPendientes({
                estado: true,
                text: 'Estado Vistos Bueno',
                value: estado.label,
                filtro: 'vistos_buenos_presentado',
              })
            "
          >
            {{ estado.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
